import {pageInfo,confirmWeighResult} from './../api';
import {Message} from 'element-ui';
import {plant} from "../../../../../api";

const weighConfirm = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    confirmWeighResultObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    CONFIRM_WEIGH_RESULT(state,data){
      state.confirmWeighResultObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async confirmWeighResult({commit}, obj){
      let resp = await confirmWeighResult(obj);
      commit('CONFIRM_WEIGH_RESULT', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
  }
}
export default weighConfirm



// WEBPACK FOOTER //
// ./src/page/bd/exceptionDeal/weighConfirm/store/weighConfirm.store.js